__turbopack_context__.v({
  "component": "style-module-scss-module__PvKWLG__component",
  "content": "style-module-scss-module__PvKWLG__content",
  "ctaButton": "style-module-scss-module__PvKWLG__ctaButton",
  "logoWrapper": "style-module-scss-module__PvKWLG__logoWrapper",
  "scrollingText": "style-module-scss-module__PvKWLG__scrollingText",
  "textContainer": "style-module-scss-module__PvKWLG__textContainer",
  "videoContainer": "style-module-scss-module__PvKWLG__videoContainer",
  "videoWrapper": "style-module-scss-module__PvKWLG__videoWrapper",
});
